import { ApiResponse } from "types";
import { IFeedback } from "interfaces";
import { Apis, Enums } from "utils";

export interface IFeedbackData {
  all(): Promise<ApiResponse<IFeedback[]>>;
  find(id: string): Promise<ApiResponse<IFeedback>>;
  insert(payload: IFeedback): Promise<ApiResponse<IFeedback>>;
  update(payload: IFeedback): Promise<ApiResponse<IFeedback>>;
  delete(id: string): Promise<ApiResponse<IFeedback>>;
}

export class FeedbackData implements IFeedbackData {
  private collection = "feedbacks";

  async all(): Promise<ApiResponse<IFeedback[]>> {
    try {
      const response = await Apis.current().get(`${this.collection}`);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: [] } as ApiResponse<IFeedback[]>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IFeedback[]>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: [] } as ApiResponse<IFeedback[]>;
    }
  }

  async find(id: string): Promise<ApiResponse<IFeedback>> {
    try {
      const response = await Apis.current().post(`${this.collection}/find`, { _id: id } as any);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IFeedback>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IFeedback>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IFeedback>;
    }
  }

  async insert(payload: IFeedback): Promise<ApiResponse<IFeedback>> {
    try {
      const response = await Apis.current().post(`${this.collection}`, payload);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IFeedback>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IFeedback>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IFeedback>;
    }
  }

  async update(payload: IFeedback): Promise<ApiResponse<IFeedback>> {
    try {
      const response = await Apis.current().put(`${this.collection}`, payload);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IFeedback>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IFeedback>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IFeedback>;
    }
  }

  async delete(id: string): Promise<ApiResponse<IFeedback>> {
    try {
      const response = await Apis.current().delete(`${this.collection}/${id}`);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IFeedback>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IFeedback>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IFeedback>;
    }
  }
}

